import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

import GoldFactsPage from "./GoldFacts";
import MuhuratCalendar from "./MuhuratCalender";
import { useAppTheme } from "../../theme/useAppTheme";

export default function ExploreScreen() {
  const [activeTab, setActiveTab] = useState(0);
  const themeColors = useAppTheme();

  const tabSx = (selected) => ({
    flex: 1,
    borderRadius: "16px",
    textTransform: "none",
    py: 1.15,
    fontWeight: 600,
    color: themeColors.text,
    background: selected ? "rgba(0, 16, 40, 0.55)" : "transparent",
    boxShadow: selected ? "inset 0 0 0 1px rgba(255,255,255,0.06)" : "none",
    "&:hover": {
      background: selected ? "rgba(0, 16, 40, 0.55)" : "rgba(255,255,255,0.06)",
    },
  });

  return (
    <Box
      sx={{
        background: themeColors.scaffoldGradientColors,
        width: "100%",
        maxWidth: 1000,
        mx: "auto",
        minHeight: "100vh",
        px: { xs: 1.5, sm: 2 },
        pt: { xs: 2, sm: 3 },
        pb: 4,
        color: themeColors.text,
      }}
    >
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <Button
          startIcon={<AutoAwesomeIcon />}
          onClick={() => setActiveTab(0)}
          sx={tabSx(activeTab === 0)}
        >
          Interesting Facts
        </Button>
        <Button
          startIcon={<CalendarMonthOutlinedIcon />}
          onClick={() => setActiveTab(1)}
          sx={tabSx(activeTab === 1)}
        >
          Muhurat Calendar
        </Button>
      </Box>

      {activeTab === 0 && <GoldFactsPage />}
      {activeTab === 1 && <MuhuratCalendar />}
    </Box>
  );
}
